/** Chemins qui ne doivent pas être indexés par les moteurs de recherche. */
const NOINDEX_EXACT = new Set([
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/dashboard',
  '/admin',
  '/profile',
  '/settings',
  '/help',
  '/learner',
  '/learners',
  '/analytics',
  '/not-found',
]);

const NOINDEX_PREFIXES = [
  '/marketing/',
  '/eduflow/',
  '/institution/',
  '/v2/',
  '/manager/',
  '/collaborator/',
  '/rh/',
  '/media/',
  '/auth/',
  '/podcasts/',
  '/webinars/',
  '/learners/',
  '/settings/',
];

export function shouldNoindexPath(pathname: string): boolean {
  const path = pathname.split('?')[0]?.replace(/\/+$/, '') || '/';

  if (path.startsWith('/podcasts/public')) return false;
  if (path.startsWith('/webinars/register') || path.startsWith('/webinars/watch')) return false;

  if (NOINDEX_EXACT.has(path)) return true;
  return NOINDEX_PREFIXES.some((prefix) => path === prefix.replace(/\/$/, '') || path.startsWith(prefix));
}
